<template>
  <div>
    <el-menu-item  @click.native="toggleChange" v-if="!menuItem.meta" :index="menuItem.children[0].path">
      <i :class="menuItem.children[0].meta.icon"></i>
      <span slot="title">{{ menuItem.children[0].meta.title }}</span>
    </el-menu-item>
    <el-submenu v-else :index="menuItem.path">
      <template slot="title">
        <i :class="menuItem.meta.icon"></i>
        <span style="font-size: 18px">{{ menuItem.meta.title }}</span>
      </template>
      <el-menu-item
        @click.native="toggleChange"
        :index="subItem.path"
        v-for="subItem in menuItem.children"
        :key="subItem.path"
      >
        <template slot="title">
          <i :class="subItem.meta.icon"></i>
          <span>{{ subItem.meta.title }}</span>
        </template>
      </el-menu-item>
    </el-submenu>
  </div>
</template>

<script>
export default {
  props: {
    menuItem: {
      default: Object,
    },
  },
  methods: {
    toggleChange() {
      this.$store.commit("toggleChange");
    },
  },
};
</script>

<style lang="less" scoped>
.el-submenu__title,
.el-menu-item {
  font-size: 18px;
}
.el-submenu {
  margin-left: -2px;
}
.el-submenu [class^="el-icon-"] {
  vertical-align: middle;
  margin-right: 0px;
  width: 30px;
  text-align: center;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/subMenu.vue